import { Calendar } from '@fullcalendar/core';
import bootstrap5Plugin from '@fullcalendar/bootstrap5';
import dayGridPlugin from '@fullcalendar/daygrid';

// Make available globally for users of the /dist folder
// Feel free to comment this out if you're working in the /src folder
window.Calendar = Calendar;
window.bootstrap5Plugin = bootstrap5Plugin;
window.dayGridPlugin = dayGridPlugin;
